import { render, staticRenderFns } from "./treatment-step-percentage.vue?vue&type=template&id=b33a46fe&"
import script from "./treatment-step-percentage.vue?vue&type=script&lang=js&"
export * from "./treatment-step-percentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports